<div class="scroll-x-- table-component table--padded" [class.loading-timed-out]="loadingTimedOut && ready">
  <!-- loadingTimedOut -->
  @if (loadingTimedOut && ready) {
    <div class="loading-timed-out-spinner">
      <app-spinner></app-spinner>
    </div>
  }
  <table class="table">
    <thead [class]="classes">
      <tr>
        @for (head of localHeads; track head) {
          <th
            [style.width]="head.width ? head.width : 'auto'"
            [style.min-width]="head.minWidth ? head.minWidth : ''"
            [class.saving]="loading || (!ready || notReady)"
            [class.sortable]="head.sortable"
            [class.shrink]="head.minWidth"
            [class.center]="head.center"
            class="saving--pre"
            (click)="head.sortable && clickSort(head)">
            <div class="position-relative">
              {{head.name}}
              @if (head.sortable) {
                <i class="sortable-icon" [ngClass]="getSortingClass(head)"></i>
              }
              <!-- column options -->
              @if (hasColumnOptions && head.code === 'actions') {
                <div class="column-options-button" (click)="openColumnOptionsModal()">
                  <i class="im-icon im-icon-settings-sliders-vert"></i>
                </div>
              }
            </div>
          </th>
        }
      </tr>
    </thead>
    @if ((ready && !notReady)) {
      <tbody [class]="classes">
        @for (item of data; track identify($i, item); let $i = $index) {
          <tr [class.active]="item[id] === selected" [class.clickable]="clickable">
            @for (head of localHeads; track identify($index, head)) {
              <td
                [class.td--mw-0]="item[head.code]?.mw0"
                [class.td--actions]="item[head.code] && item[head.code].type === 'actions'"
                [class.td--flags]="item[head.code] && item[head.code].type === 'flags'"
                [class.shrink]="item[head.code] && (item[head.code].type === 'actions' || item[head.code].type === 'flags')"
                [class.linethrough]="item && item.linethrough && item[head.code] && head.code !== 'actions'" class="saving--pre {{(item[head.code]?.classList || '')}}"
                [class.saving]="loading"
                [class.editing]="item[head.code] && item[head.code].type === 'object' && item[head.code].object.editable && editing"
                >
                <!-- link -->
                @if (item.routerLink) {
                  <a (click)="false && $event.preventDefault(); clickData.emit({item: item, head: head.code})" draggable="false" [routerLink]="[item.routerLink]" queryParamsHandling="preserve" class="pad d-flex align-items-center">
                    <ng-container [ngTemplateOutlet]="tdData" [ngTemplateOutletContext]="{item: item, head: head, $i: $i}"></ng-container>
                  </a>
                }
                <!-- no link -->
                @if (!item.routerLink) {
                  <div (click)="$event.preventDefault(); clickData.emit({item: item, head: head.code})" class="pad d-flex align-items-center">
                    <ng-container [ngTemplateOutlet]="tdData" [ngTemplateOutletContext]="{item: item, head: head, $i: $i}"></ng-container>
                  </div>
                }
              </td>
            }
          </tr>
        }
      </tbody>
    }
    <!-- shimmer -->
    @if ((!ready || notReady)) {
      <tbody class="shimmer-body">
        @for (item of shimmerRows; track item) {
          <tr>
            <td [attr.colspan]="localHeads.length"><app-shimmer></app-shimmer></td>
          </tr>
        }
      </tbody>
    }
  </table>
</div>
<!-- emptystate -->
@if (!loading && data && !data.length && emptyState) {
  <div class="mt-s empty-state-wrapper" [class]="classes">
    <app-empty-state [value]="emptyState"></app-empty-state>
  </div>
}
<!-- pagination / export -->
@if ((ready && !notReady) && data && data.length) {
  <div class="row mt-l">
    <div class="col-4 d-flex align-items-center">
      @if (exportLabel) {
        <div class="d-flex w-100">
          <button (click)="clickExport.emit()" [class.disabled]="exportBusy" class="button-link fontsize-s export-btn">
            @if (!exportBusy) {
              <i class="im-icon im-icon-download"></i>
            }
            @if (exportBusy) {
              <app-inline-spinner style="display: block; margin-right: 4px; transform: translateY(-1px);"></app-inline-spinner>
            }
            <span class="underline">{{exportLabel}}</span>
          </button>
        </div>
      }
      @if (backToOverviewText && backToOverviewLink) {
        <div class="d-flex w-100">
          <a class="link" [routerLink]="[backToOverviewLink]">{{ backToOverviewText }}</a>
        </div>
      }
    </div>
    <div class="col-4">
      @if (totalRows > RPP) {
        <div class="d-flex justify-content-center" [class.saving]="loading">
          <app-pagination
            [RPP]="RPP"
            [startRow]="startRow"
            [totalRows]="totalRows"
            (startRowChange)="startRowChange.emit($event)">
          </app-pagination>
        </div>
      }
    </div>
    <div class="col-4 d-flex flex-row align-items-center">
      @if (exportLabel) {
        <div class="d-flex w-100 justify-content-end">
          <!--  -->
        </div>
      }
    </div>
  </div>
}


<!-- tData template -->
<ng-template #tdData let-item='item' let-head='head' let-$i="$i">
  <!-- default -->
  @if (!item[head.code] || !item[head.code].type) {
    {{head.code === 'empty' ? '' : item[head.code] | display}}
  }

  <!-- default type (with props) -->
  @if (item[head.code] && item[head.code].type === 'default') {
    <span [class.data-ellipsis]="item[head.code].ellipsis" [ngStyle]="{'color': item[head.code].color ? item[head.code].color : ''}" [class.has-stamps]="item[head.code]?.stamps?.length" [class]="item[head.code].classList" [class.low-opacity]="!item[head.code].value">{{item[head.code].value | display: item[head.code].placeholder }}</span>
  }

  <!-- title -->
  @if (item[head.code] && item[head.code].type === 'title') {
    <span [class.data-ellipsis]="item[head.code].ellipsis" [class.has-stamps]="item[head.code]?.stamps?.length" class="title">{{item[head.code].title | display: item[head.code].placeholder}}</span>
  }

  <!-- titleSubtitle -->
  @if (item[head.code] && item[head.code].type === 'titleSubtitle') {
    <div class="d-inline-flex flex-column title-subtitle"><span class="title">{{item[head.code].title}}</span>@if (item[head.code].subtitle) {
    <span class="subtitle">{{item[head.code].subtitle}}</span>
  }</div>
}

<!-- ts -->
@if (item[head.code] && item[head.code].type === 'ts') {
  <span style="white-space: nowrap;">{{item[head.code].ts | formatTs: item[head.code].format : item[head.code].unix || false}}</span>
}

<!-- tile -->
@if (item[head.code] && item[head.code].type === 'tile') {
  <span [class.title]="!item[head.code].small">{{ item[head.code][head.code] }}</span> @if (item[head.code].tile) {
  <span class="tile" [class.primary-tile]="!item[head.code][head.code]" [class]="item[head.code].classList">{{ item[head.code].tile }}</span>
}
}

<!-- tiles -->
@if (item[head.code] && item[head.code].type === 'tiles') {
  @for (tile of item[head.code].tiles; track tile) {
    <span class="tile" [class]="tile.classList"
      placement="top-right"
      [autoClose]="false"
      tabindex="0"
      triggers="hover focus"
      [ngbTooltip]="tooltip"
      [container]="'body'"
      [disableTooltip]="!tile.tooltip_title && !tile.tooltip_descr"
      [openDelay]="100"
      [closeDelay]="100"
      >{{ tile.value }}
      <ng-template #tooltip>
        @if (tile.tooltip_title) {
          <div class="title">{{tile.tooltip_title}}</div>
        }
        @if (tile.tooltip_descr) {
          <div class="descr">{{tile.tooltip_descr}}</div>
        }
      </ng-template>
    </span>
  }
}

<!-- icon -->
@if (item[head.code] && item[head.code].type === 'icon') {
  <i class="im-icon icon" [ngClass]="[item[head.code].icon, item[head.code].class]"></i>
}

@if (item[head.code] && item[head.code].type === 'link') {
  <a [ngClass]="item[head.code].class" (click)="onLinkClicked($event, item[head.code].link, item)">
    {{item[head.code].name}}
  </a>
}

<!-- object -->
@if (item[head.code] && item[head.code].type === 'object') {
  @if (!editing || !item[head.code].object.editable) {
    <span
      [class.title]="item[head.code].object[parameter]"
      [class.low-opacity]="!item[head.code].object[parameter]"
      [class]="item[head.code].classList"
      >
      {{ item[head.code].object[parameter] }}
    </span>
  }
  @if (editing && item[head.code].object.editable) {
    <div
      class="justify-content-center w-100">
      <app-field-text
        type="integer"
        [errorTooltip]="item[head.code].error"
        [class.changed]="item[head.code].changed"
        [model]="item[head.code].object[parameter]"
        (modelChange)="onModelChange(item, head.code, $event)"
      ></app-field-text>
    </div>
  }
}

<!-- flags -->
@if (item[head.code] && item[head.code].type === 'flags') {
  @if (item[head.code].flags?.length) {
    <div class="flags">
      @for (flag of item[head.code].flags; track flag) {
        <div class="flag">
          <i
            placement="top-right"
            [autoClose]="false"
            tabindex="0"
            triggers="hover focus"
            [ngbTooltip]="tooltipFlag"
            [container]="'body'"
            [disableTooltip]="!flag.tooltip_title && !flag.tooltip_descr"
            tooltipClass="tooltip--flag"
            [openDelay]="100"
            [closeDelay]="100"
            class="im-icon im-icon-flag"
            [style.color]="flag.color">
          </i>
          <ng-template #tooltipFlag>
            @if (flag.tooltip_title) {
              <div class="title"><i class="im-icon im-icon-flag" [style.color]="flag.color"></i> {{flag.tooltip_title}}</div>
            }
            @if (flag.tooltip_descr) {
              <div class="descr">{{flag.tooltip_descr}}</div>
            }
          </ng-template>
        </div>
      }
    </div>
  }
}

@if (item[head.code] && item[head.code].type === 'button') {
  <app-button
    class="align-left"
    classes="primary-default"
    icon="plus-round"
    [disabled]="item[head.code].disabled"
    [text]="item[head.code].text"
    (emitClick)="onButtonClicked(item)"
  ></app-button>
}

<!-- actions -->
@if (item[head.code] && item[head.code].type === 'actions') {
  @if (item[head.code].actions && item[head.code].actions.length) {
    <div class="action-button d-flex align-items-center actions position-relative" [class.active]="helper.action === $i" [ngbPopover]="popContent" [container]="'body'" placement="bottom-right" (shown)="helper.action = $i" (hidden)="helper.action = null" (click)="$event.stopPropagation(); $event.preventDefault();">
      <i class="im-icon im-icon-actions"></i>
      <ng-template #popContent>
        <ul>
          @for (action of item[head.code].actions; track identify($index, action)) {
            <li class="position-relative" appClickOutside (clickOutside)="helper.action = null" (click)="actionClick($event, action, $i, item)" [ngClass]="action.class || ''">
              @if (action.icon) {
                <i class="im-icon im-icon-{{action.icon}}"></i>
              }
              {{action.name}}
            </li>
          }
        </ul>
      </ng-template>
      @if (helper.actionItem) {
        <app-confirm-action-modal [open]="helper.confirm === $i" [confirmTitle]="helper.actionItem.confirmTitle" [confirmDescr]="helper.actionItem.confirmDescr" (confirmed)="clickAction.emit({item: item, action: helper.actionItem.code}); helper.confirm = null; helper.action = null;" (cancelled)="helper.confirm = null; helper.action = null;"></app-confirm-action-modal>
      }
    </div>
  }
}

<!-- stamps -->
@if (item[head.code]?.stamps?.length) {
  <div class="stamps">
    <span class="spacer"></span>
    @for (stamp of item[head.code].stamps; track stamp) {
      <span class="stamp" [class]="stamp.class">{{stamp.value}}</span>
    }
  </div>
}
</ng-template>